module.exports = __webpack_public_path__ + "static/media/contact-us-cropped.142a182c.png";